<template>
	<div v-if="loaded">
		<div class="breadcrumbs" id="breadcrumbs">
			<router-link class="breadcrumb-link" to="/campaigns/">All Bookblock HUB Campaigns</router-link>  &gt;
			<router-link class="breadcrumb-link" :to="'/campaigns/' + item.id">{{ item.name }}</router-link>
		</div>
		<h3>{{ item.name }} <span><span v-if="item.reward_type=='voucher'">Voucher</span><span v-else>Gift</span> Campaign</span><span class="preview" v-if="team.plan!='pro'"> PREVIEW</span></h3>

		<div class="ws-large-tab-menu">
			<router-link :to="'/campaigns/' + item.id">Summary</router-link>
			<router-link :to="'/campaigns/' + item.id + '#recipients'">Recipients</router-link>
			<router-link v-if="item.type == 'sales'" :to="'/campaigns/' + item.id + '/analytics'">Analytics</router-link>
			<router-link v-if="item.type == 'reviews'" :to="'/campaigns/' + item.id + '/feedback'">Feedback</router-link>
		</div>

		<!--
		<table id="campaign-summary" class="ws-table-summary">
			<thead>
			<tr>
				<th>Status</th>
				<th>Type</th>
				<th>Reward Type</th>
				<th>Privacy</th>
				<th>Request Date</th>
				<th>Registrations</th>
			</tr>
			</thead>
			<tbody>
			<tr>
				<td class="field-status" data-label="Status" :data-status="item.status" style="width: 120px"><div class="value">{{ item.status }}</div></td>
				<td class="field-type" data-label="Type" :data-type="item.type" style="width: 200px"><div class="value"><b>{{ item.type }} Campaign</b></div></td>
				<td class="field-reward-type" data-label="Reward Type" style="width: 120px"><div class="value">{{ item.reward_type }}</div></td>
				<td class="field-privacy" data-label="Privacy" style="width: 100px"><div class="value">{{ privacyLevels[item.privacy] }}</div></td>
				<td class="field-start_date" data-label="Request Date">{{ item.requested_at }}</td>
				<td class="field-registrations" data-label="Registrations"><i>{{ registrations.meta.invited_count }}</i> invited &nbsp;&nbsp;&nbsp; <i class="positive">{{ registrations.meta.confirmed_count }}</i> confirmed <span v-if="registrations.meta.unconfirmed_count!=0"> &nbsp;&nbsp;&nbsp; <i class="negative">{{ registrations.meta.unconfirmed_count }}</i> for confirmation</span></td>
			</tr>
			</tbody>
		</table>
		-->

		<gift-box-campaigns-analytics v-if="item.analytics" :item="item" :params="analyticsParams" @configureSales="configureSales"></gift-box-campaigns-analytics>

		<div class="campaign-page-info">
			<div id="campaign-gift-claim-page-area" v-if="item.privacy=='public'" style="margin-bottom: 10px;">
				<h4>Campaign Gift Claim Page</h4>
				<div id="campaign-page-info-url" class="copy-url">
					<a id="campaign-page-url" class="copy-url-url" target="_blank" :href="item.registration_page">{{ item.registration_page }}</a>
					<div @click="copyToClipboard(item.registration_page)" class="ws-button ws-button-small">Copy URL</div>
					<!-- <a v-else target="_blank" :href="item.registration_page" class="ws-button ws-button-small ws-button-secondary">Preview This Page</a> -->
				</div>
				<!--<p id="campaign-page-info-text" v-if="item.privacy=='invite' && item.page_restricted">This is a <b>restricted-access private</b> campaign. The page above without an invitation code in the URL is only accessible to you.<br>To share the gift registration link, please <a href="#" @click.prevent="modals.giftInviteModal = true">generate unique link</a> for each of your invitees using the button below.</p>
				<p id="campaign-page-info-text" v-else-if="item.privacy=='invite'">This is a <b>private</b> campaign. Anybody can see your campaign options using the link above, but only invited people can register for a gift.<br>To share the gift registration link, please <a href="#" @click.prevent="modals.giftInviteModal = true">generate unique link</a> for each of your invitees using the button below.</p>-->
				<p id="campaign-page-info-text">This is an <b>open</b> campaign. Anybody can see your campaign options using the link above and register for a gift.<!-- <br>In addition to standard sharing tools below, you can <a href="#" @click.prevent="copyToClipboard('https://hub.bookblock.com' + gbPageUrl(team.slug, item.slug))">copy this public URL</a> of this campaign and share it externally.<br>You will need to confirm each public registration before we can process it.--></p>

				<div v-if="item.status=='leaked'" class="small-note error">This campaign has been marked as <b>leaked</b>. Claiming the gift via the public gift claim page is disabled and you can't send any new invitations for this campaign.</div>

			</div>

			<h4>Gift Options</h4>
			<p style="margin-top: -10px">To request a new gift option or a change, please <a href="#" @click.prevent="openContactModal">contact your Account Manager</a>.</p>
			<div class="gift-options">
				<div v-for="(option, i) in item.options" class="gift-option" :class="'gift-option-'+option.type">

					<div class="gift-option-img" :style="'background-image: url(' + option.image_url + ')'"></div>
					<span class="gift-option-no">Option #{{ i + 1 }} - <i>{{ giftOptionTypeName(option.type) }}</i></span>
					<div class="gift-option-is-active" :class="option.product_status">{{ option.product_status }}</div>
					<h5><a style="cursor:pointer" @click="openOptionEditModal(option.id)"><b v-if="option.type=='voucher'">{{ option.voucher_value | toCurrency }} </b>{{ option.name }}</a></h5>
					<div class="gift-option-params">
						<!--div class="gift-option-param" v-if="option.type=='physical'"><b>{{ option.price_ex_vat | toCurrency }}</b> per unit <span class="inc-vat">({{ option.price | toCurrency }} inc. VAT)</span></div>-->
						<div class="gift-option-param" ><b>{{ option.reg_count }}</b> gift delivery registrations</div>
						<div class="gift-option-param" v-if="option.type=='physical'"><b>{{ option.available }}</b> units available
							<div v-if="option.available == 0" class="gift-availability none">Unavailable</div>
							<div v-else-if="option.available <= 2" class="gift-availability low">Low Availability</div>
						</div>
					</div>
					<div class="ws-button small" style="margin-top: 30px" @click="openOptionEditModal(option.id)">DETAILS</div>
				</div>
				<div v-if="!item.options.length" class="small-note error"><b>There are no gift options</b> for this campaign.</div>
			</div>
		</div>

		<div id="campaign-actions" class="tool-actions">
			<div class="tool-actions-left">
				<div class="ws-button ws-button-main" @click="modals.giftRegistrationModal = true" v-if="item.status === 'active' && !['sales','reviews'].includes(item.type) && team.corporation_id != 5" v-tooltip="'Choose the gift on behalf of the recipient and we\'ll send it directly to them.'+voucherExtraTooltip('Vouchers get charged and fulfilled immediately when sent.')">Select & Send</div>
				<div class="ws-button ws-button-main" @click="openGiftRegistrationLinkModal(null)" v-if="item.status === 'active'" v-tooltip="'Generate unique gift registration link that you can share with your recipient with optional extra security by requiring them to use correct name or email.</i>'+voucherExtraTooltip('Vouchers gets charged and fulfilled when being claimed by the recipient.')" >Create A New Invitation</div>
				<div class="ws-button" v-if="item.status === 'active' && item.reward_type!='voucher' && user.permissions && user.permissions.includes('use-balance') && team.corporation_id != 5" @click="openMultiModal('send')" v-tooltip="'Upload recipients CSV and send gifts in bulk.'">Multi Send</div>
				<div class="ws-button" v-if="item.status === 'active' && user.permissions && user.permissions.includes('use-balance') && team.corporation_id != 5" @click="openMultiModal('link')" v-tooltip="'Upload recipients CSV and get a gift registration link for all of them.'">Multi Invite</div>
			</div>
			<div class="tool-actions-right">
				<div class="ws-button ws-button-secondary" @click="openSettings" v-if="item.status !== 'completed'" v-tooltip="'Manage your campaign\'s name, privacy settings and gift registration page content.'">Campaign Settings</div>
				<div class="ws-button ws-button-secondary" v-if="team.integrations.length >= 1 && item.status === 'active'" @click="modals.campaignIntegrationsModal = true" v-tooltip="'Unique links to be used in your connected CRM integrations.'">CRM</div>
				<div class="ws-button ws-button-secondary" v-if="item.reward_type!='voucher'" @click="modals.notecardModal = true" v-tooltip="'Set personalised notecards that will be included with every gift.'+voucherExtraTooltip('For physical gifts only. Vouchers are excluded.')">Notecards</div>
				<a class="ws-button ws-button-secondary" target="_blank" :href="item.registration_page" v-if="['active','paused','leaked','completed'].includes(item.status)" v-tooltip="'Display a preview of gift claim page that your recipients see when claiming a gift.'">Gift Page Preview</a>
			</div>
		</div>

		<div v-if="['active', 'paused', 'leaked', 'completed'].includes(item.status)" id="recipients" ref="recipients">
			<h3 style="float: left;" v-if="item.reward_type=='voucher'">Gift Card Recipients</h3>
			<h3 style="float: left;" v-else>Gift Box Recipients</h3>

			<div class="ws-filters">
                <div class="ws-filter ws-filter-search">
                    <label>Search by name or email</label>
                    <input type="text" v-model="pageParams.search.val" @keyup="setFilter" placeholder="Search query...">
                </div>
                
				<div class="ws-filter ws-filter-select" v-if="user.permissions && user.permissions.includes('view-others-orders')">
					<label>Added By</label>
					<select v-model="pageParams.filters.invited_by.val" @change="setFilter">
						<option value="null">All Team Members</option>
						<option  v-for="member in team.managers" v-bind:value="member.user_id" v-if="['manager','associate'].includes(member.role)">{{ member.name }}</option>
					</select>
				</div>

				<div class="ws-filter ws-filter-select">
					<label>Invitation Method</label>
					<select v-model="pageParams.filters.registration_method.val" @change="setFilter">
						<option value="null">All Invitation Methods</option>
						<option  v-for="method in giftRegistrationMethods" v-bind:value="method.type" v-if="showMethodInFilter(method)">{{ method.label }}</option>
					</select>
				</div>
				
				<div class="ws-filter ws-filter-select" v-if="item.reward_type=='physical'">
					<label>Delivery Status</label>
					<select v-model="pageParams.filters.delivery_status.val" @change="setFilter">
						<option value="null">Any Status</option>
						<option v-for="status in giftFulfillmentStatus" v-bind:value="status.status">{{ status.label }}</option>
					</select>
				</div>

				<div class="ws-filter" v-if="item.type=='sales'">
					<label>Opened</label>
					<div class="ws-filter-switch" :data-state="filterToYesNo('visited_at')" @click="toggleFilter('visited_at')"><div class="ws-filter-switch-knob"></div></div>
				</div>

				<div class="ws-filter">
					<label>Gift Chosen</label>
					<div class="ws-filter-switch" :data-state="filterToYesNo('option_id')" @click="toggleFilter('option_id')"><div class="ws-filter-switch-knob"></div></div>
				</div>

                <div class="ws-filter" v-if="item.reward_type!='voucher'">
                    <label>Confirmed</label>
                    <div class="ws-filter-switch" :data-state="filterToYesNo('confirmed_at')"
                         @click="toggleFilter('confirmed_at')">
                        <div class="ws-filter-switch-knob"></div>
                    </div>
                </div>

				<div class="ws-filter">
					<label>Sent</label>
					<div class="ws-filter-switch" :data-state="filterToYesNo('sent_at')" @click="toggleFilter('sent_at')"><div class="ws-filter-switch-knob"></div></div>
				</div>

				<div class="ws-filter ws-filter-rejected">
					<label>Rejected</label>
					<div class="ws-filter-switch" :data-state="filterToYesNo('rejected_at')" @click="toggleFilter('rejected_at')"><div class="ws-filter-switch-knob"></div></div>
				</div>
			</div>

			<div class="large-table-wrap">
				<table id="list-of-recipients"  class="worksends-table cb-table status-">
					<thead>
					<tr>
						<th class="field-r_name"><div class="sortable" :class="sortClass('last_name', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('last_name')">Recipient</div></th>
						<th class="field-rating" v-if="item.type=='reviews'"><div class="sortable" :class="sortClass('rating', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('rating')">Rating</div></th>
						<th class="field-method"><div class="sortable" :class="sortClass('registration_method', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('registration_method')">Invitation Method</div></th>
						<!-- <th class="field-g_invited"><div class="sortable" :class="sortClass('invited_at', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('invited_at')">Invited</div></th> -->
						<th class="field-approved" v-if="team.corporation_id == 5">Approved</th>
						<th class="field-g_visited" v-if="item.type=='sales'"><div class="sortable" :class="sortClass('visited_at', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('visited_at')">Opened</div></th>
						<th class="field-g_registered"><div class="sortable" :class="sortClass('registered_at', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('registered_at')">Registered</div></th>
						<th class="field-g_confirmed" v-if="item.reward_type!='voucher'"><div class="sortable" :class="sortClass('confirmed_at', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('confirmed_at')">Confirmed</div></th>
						<th class="field-g_sent"><div>Fulfillment</div></th>
						<th class="field-demo_booked" v-if="item.type=='sales'">Demo Booked</th>
						<th class="field-deal_closed" v-if="item.type=='sales'">Deal Closed</th>
						<th class="field-costs">Total</th>
						<th class="field-actions">Actions</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="r, i in registrations.data" :registration-id="r.id">
						<td class="field-r_name" data-label="Recipient">
							<div class="value">
                                <b>{{ r.first_name }} {{ r.last_name }}</b>
                                <span v-if="r.company"> ({{r.company}})</span>
                            </div>
							<div class="value">{{ r.email }}</div>
							<div class="batch-label" v-if="r.batch_label" @click="openBatchDetailModal(r.shared_secret)"><i>{{ r.batch_label }}</i></div>
						</td>
						<td class="field-rating" data-label="Rating" v-if="item.type=='reviews'">
							<div class="value"><div :class="'feedback-rating rating-'+r.rating" @click="openFeedbackModal(r)">{{ verbalRating(r.rating) }}</div></div>
						</td>
						<td class="field-registration_method" data-label="Registration Method" :class="r.registration_method" style="width: 140px;">
							<div class="value">
								<div class="yesno" :class="r.registration_method">
									{{ registrationMethodName(r.registration_method) }}
									<div v-if="r.integration" class="yesno-by"><i>{{ r.integration }}</i></div>
									<div v-if="r.invited_at && r.invited_by_name" class="yesno-by i">{{ r.invited_by_name }}</div>
									<div v-else-if="r.registered_at && r.registered_by_name" class="yesno-by r">{{ r.registered_by_name }}</div>
								</div>
							</div>
						</td>
						<td class="field-approved" v-if="team.corporation_id == 5">
							<div class="ws-filter live-property">
								<div v-if="['associate'].includes(user.role)" class="ws-filter-switch readonly" :data-state="dynamicPropertyValue(r.approved.status,true)"><div class="ws-filter-switch-knob"></div></div>
								<div v-else class="ws-filter-switch" :data-state="dynamicPropertyValue(r.approved.status,true)" @click="saveDynamicProperty('approved',r,i)"><div class="ws-filter-switch-knob"></div></div>
								<div v-if="r.approved.date" class="yesno-date"><i>{{ r.approved.date }}</i></div>
							</div>
						</td>
						<td class="field-g_visited" data-label="Visited" v-if="item.type=='sales'">
							<div class="value">
								<div v-if="r.visited_at" class="yesno yes">Yes
									<!-- <div class="yesno-date">{{ r.confirmed_at }}</div> -->
								</div>
								<div v-else class="yesno no">No</div>
							</div>
						</td>
						<td class="field-g_registered" data-label="Registered">
							<div class="value">
								<div v-if="(r.registered_at && Number(r.option_id)!=0)" class="yesno yes">
									{{ r.option_name }}
									<span v-if="r.quantity > 1" class="quantity"> ({{ r.quantity }}x)</span>
									<div v-if="r.size" class="quantity">Size {{ r.size }}</div>
									<div class="yesno-date">{{ r.registered_at }}</div>
								</div>
								<div v-else-if="r.registered_at && r.rejected_at" class="yesno no">OPTED-OUT
									<div class="yesno-date">{{ r.registered_at }}</div>
								</div>
								<div v-else class="yesno no">No</div>
							</div>
						</td>
						<td class="field-g_confirmed" data-label="Confirmed" v-if="item.reward_type!='voucher'">
							<div class="value">
								<div v-if="r.rejected_at" class="yesno no">Rejected</div>
								<div v-else-if="r.confirmed_at" class="yesno yes">Yes
									<!-- <div class="yesno-date">{{ r.confirmed_at }}</div> -->
								</div>
								<div v-else class="yesno no">No</div>
							</div>
						</td>
						<td class="field-g_sent" data-label="Fulfillment">
							<div class="value">
								<div v-if="r.delivery_status && ['return','lost'].includes(r.delivery_status) && r.delivery_resolution" class="yesno yes">Resolved ({{ r.delivery_status }}) <a class="ws-tracking-link" v-if="r.tracking_url" :href="r.tracking_url" target="_blank" >Tracking Link →</a><div class="yesno-date">{{ r.delivery_status_date }}</div></div>
                                <div v-else-if="r.delivery_status && ['return','lost'].includes(r.delivery_status)" class="yesno no">{{ r.delivery_status }}  <a class="ws-tracking-link" v-if="r.tracking_url" :href="r.tracking_url" target="_blank" >Tracking Link →</a><div class="yesno-date">{{ r.delivery_status_date }}</div></div>
								<div v-else-if="!r.sent_at && !r.processed_at" class="yesno">No<div class="yesno-date">{{ r.sent_at }}</div></div>
								<div v-else-if="!r.sent_at && r.processed_at" class="yesno yes">
                                    Processing
                                    <div class="yesno-date">{{ r.processed_at }}</div>
                                    <div class="yesno-date" style="font-size: 11px; color: #2e5892" v-if="r.expected_shipping_date">Shipping <b>{{ r.expected_shipping_date }}</b></div>
                                </div>
								<div v-else-if="r.sent_at" class="yesno yes">Sent <a class="ws-tracking-link" v-if="r.tracking_url" :href="r.tracking_url" target="_blank" >Tracking Link →</a><div class="yesno-date">{{ r.sent_at }}</div></div>
								<div v-else class="yesno">No</div>
							</div>
						</td>

						<td class="field-demo_booked" data-label="Demo Booked" v-if="item.type=='sales'">
							<div class="ws-filter live-property">
								<div class="ws-filter-switch" :data-state="dynamicPropertyValue(r.demo_booked)" @click="saveDynamicProperty('demo_booked',r,i)">
									<div class="ws-filter-switch-knob"></div>
								</div>
							</div>
						</td>

						<td class="field-deal_closed" data-label="Deal Closed" v-if="item.type=='sales'">
							<div class="ws-filter live-property">
								<div class="ws-filter-switch" :data-state="dynamicPropertyValue(r.deal_closed)" @click="saveDynamicProperty('deal_closed',r,i)">
									<div class="ws-filter-switch-knob"></div>
								</div>
							</div>
						</td>

						<td class="field-costs" data-label="Total Amount Paid">
							<div class="value" v-if="(r.registered_at && Number(r.option_id)!=0)">{{ registrationPaidAmount(r) | toCurrency }}
								<div class="value inc-vat">{{ registrationPaidAmount(r,true) | toCurrency }} inc VAT</div>
							</div>
                            <div v-if="r.payment_method === 'stripe'" class="yesno yes">CARD PAYMENT</div>
						</td>
						<td class="field-actions" data-label="Actions" style="width: 180px;" >
							<div class="value">
								<div v-if="!r.registered_at && !r.option_name && !['link','multiple-link','external'].includes(r.registration_method)" @click="updateRegistrationAction(r, 'remind')" class="ws-button small">Remind</div>
								<div v-if="!r.registered_at && !r.option_name && !['link','multiple-link','external'].includes(r.registration_method)" class="ws-button small" @click="openEditRegistration(r)">Pick</div>
								<div v-if="!r.rejected_at && !r.option_name && ['link','multiple-link','external'].includes(r.registration_method)" @click="openGiftRegistrationLinkModal(r)" class="ws-button small">Gift Claim Link</div>
								<div v-if="r.registered_at && !r.confirmed_at && !r.rejected_at && parseInt(r.option_id)" @click="updateRegistrationAction(r, 'confirm')" class="ws-button small">Approve</div>
								<div v-if="r.registered_at && !r.confirmed_at && !r.rejected_at && parseInt(r.option_id)" @click="updateRegistrationAction(r, 'reject')" class="ws-button small ws-button-negative">Reject</div>

                                <div v-else-if="r.processed_at && ['return','lost'].includes(r.delivery_status) && !r.delivery_resolution" class="ws-button ws-button-primary small" @click="resolveEditRegistration(r)">Mark as Resolved</div>
								<div v-if="!r.processed_at && r.registered_at && !r.rejected_at && team.corporation_id != 5" class="ws-button small" @click="openEditRegistration(r)">Edit Details</div>
								<div v-else-if="r.processed_at || r.rejected_at" class="ws-button ws-button-secondary small" @click="openEditRegistration(r)">View Details</div>
								
								<div class="ws-button ws-button-secondary ws-button-note small" @click="openNoteModal(r)">&nbsp;</div>
							</div>
						</td>
					</tr>
					</tbody>
				</table>
			</div>

			<ws-table-meta :meta="registrations.meta" :sum="'There are % gift registrations in total '+registrationSumExtra+'.'"></ws-table-meta>

			<div id="registrations-list-actions">
				<a class="ws-button ws-button-secondary" :download="csvFileName" v-if="!['new', 'requested'].includes(item.status) && team.plan=='pro'" @click="exportCampaign(item.id)" v-tooltip="'Download CSV summary file of all gift registrations in this campaign.'">CSV Summary</a>
			</div>

		</div>

		<gift-registration-modal v-if="modals.giftRegistrationModal" :campaign-id="item.id" :fetch-item="false" @created="onSelectSend" :type="'create'"></gift-registration-modal>
		<gift-registration-modal v-if="modals.giftRegistrationModalEdit" :campaign-id="item.id" :fetch-item="false" :registration-id="editRegId" @created="onEditRegistration" :type="'edit'"></gift-registration-modal>
		<gift-registration-note-modal v-if="modals.giftRegistrationNoteModal" :registration-id="editRegId" @created="onEditRegistration" :type="'edit'"></gift-registration-note-modal>

		<gift-invite-modal v-if="modals.giftInviteModal" :registration-link-details="registrationLinkDetails" platform="gifting" :campaign-id="item.id" @generated="onLinkGenerate"></gift-invite-modal>
		<gift-box-campaigns-multi-send-modal v-if="modals.giftBoxCampaignsMultiModal" :campaign-id="item.id" :type="multiModalType" :fetch-item="false" :batch="batch" @sent="onMultiSent" ></gift-box-campaigns-multi-send-modal>

		<gift-box-campaigns-edit-modal v-if="modals.editGiftBoxCampaign" @updated="onCampaignUpdated" type="edit" :tab="editModalTab"></gift-box-campaigns-edit-modal>
		<gift-box-campaigns-option-modal v-if="modals.giftBoxCampaignsOptionEdit" type="edit" :option-id="editOptionId" :fetch-item="true" @updated="onEditOption"></gift-box-campaigns-option-modal>
		<gift-box-campaigns-option-modal v-if="modals.giftBoxCampaignsOptionCreate" type="create" @created="onCreateOption"></gift-box-campaigns-option-modal>
		<notecard-modal v-if="modals.notecardModal" @updated="onNotecardUpdated" :text="item.notecard_text" :enabled="Boolean(item.notecard_enabled)" :design="team.notecard_url"></notecard-modal>
		<batch-detail-modal v-if="modals.batchDetailModal" :campaign-id="item.id" :batch-id="batchSecret" :batch-link="batchLink" @add-more="addMoreToBatch" @batch-renamed="batchRenamed" location="campaign"></batch-detail-modal>
		<feedback-modal v-if="modals.feedbackModal" :registration="feedbackRegistration"></feedback-modal>

		<gift-box-campaigns-integrations-modal v-if="modals.campaignIntegrationsModal" @updated="onCampaignUpdated"></gift-box-campaigns-integrations-modal>
	</div>
</template>
<script>

import NotecardModal from "@/components/modals/NotecardModal";
import GiftRegistrationModal from '@/components/modals/GiftRegistrationModal';
import GiftRegistrationNoteModal from '@/components/modals/GiftRegistrationNoteModal';
import GiftInviteModal from "@/components/modals/GiftInviteModal";

import GiftBoxCampaignsEditModal from '@/pages/gift-box-campaigns/GiftBoxCampaignsEditModal';
import GiftBoxCampaignsOptionModal from "@/pages/gift-box-campaigns/GiftBoxCampaignsOptionModal";
import GiftBoxCampaignsMultiSendModal from "@/pages/gift-box-campaigns/GiftBoxCampaignsMultiSendModal";
import BatchDetailModal from "@/pages/gift-box-campaigns/GiftBoxCampaignsBatchDetailModal";
import FeedbackModal from "@/pages/gift-box-campaigns/GiftBoxCampaignsFeedbackModal";
import GiftBoxCampaignsIntegrationsModal from '@/pages/gift-box-campaigns/GiftBoxCampaignsIntegrationsModal';
import GiftBoxCampaignsAnalytics from '@/pages/gift-box-campaigns/components/GiftBoxCampaignsAnalytics';

export default {
	name: "GiftBoxCampaignsDetail",
	components: {NotecardModal, GiftBoxCampaignsEditModal, GiftRegistrationModal, GiftRegistrationNoteModal, GiftBoxCampaignsOptionModal, GiftBoxCampaignsMultiSendModal, GiftInviteModal, BatchDetailModal, FeedbackModal, GiftBoxCampaignsIntegrationsModal, GiftBoxCampaignsAnalytics},
	data() {
		return {
			loaded: false,
			editRegId: null,
			editOptionId: null,
			registrationLinkDetails: {},
			todayDate: new Date(),
			multiModalType: null,
			batchSecret: null,
			batchLink: '',
			batch: {},
			feedbackRegistration: null,
			editModalTab: 'campaign',
			pageParams: {
				pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 10},
				search: {val: ""},
				filters: {
					option_id: { val: null, type: 'single' },
					visited_at: { val: null, type: 'single' },
					confirmed_at: { val: null, type: 'single' },
					sent_at: { val: null, type: 'single' },
					rejected_at: { val: null, type: 'single' },
					registration_method: { val: null, type: 'single' },
					delivery_status: { val: null, type: 'single' },
					invited_by: { val: null, type: 'single' },
				}
			},
			analyticsParams: {
				mode: 'statistics',
				userRange: 'all',
				dateRange: 'all-time'
			},
		}
	},
	methods: {
        async getPage(params) {
            console.log(this.pageParams);
            this.getPageHandler({
                waitName: 'gb_registrations.index',
                action: 'fetchCampaignGiftBoxRegistrations', // vuex action
                routeParams: {campaignId: this.$route.params.id},
                pageParams: this.pageParams,
                isInit: params ? params.init : false, // parse from url query params
                pushRoute: false, // push pagination params and search q to route
                resetPagination: params ? params.resetPagination : false // new search input || filters -> need to reset page & sorting
            });
            return this.fetchData();
        },
        async fetchData() {
            await this.dispatchWaitAndNotify('fetchGiftBoxCampaign', {
                campaignId: this.$route.params.id,
                params: {
                    with_option_counts: true,
                    analytics: this.analyticsParams,
                }
            }, false, true);
            this.loaded = true;
        },
        openSettings() {
            if (!this.proCheck('Changing campaign settings')) return;
            this.editModalTab = 'campaign';
            this.modals.editGiftBoxCampaign = true;
        },
        configureSales() {
            if (!this.proCheck('Changing campaign settings')) return;
            this.editModalTab = 'sales';
            this.modals.editGiftBoxCampaign = true;
        },
        onCampaignUpdated() {
            this.modals.editGiftBoxCampaign = false;
            this.fetchData();
        },
        gbPageUrl(teamSlug, campaignSlug) {
            return `/${this.gbPageUrlBase}/${teamSlug}/${campaignSlug}`;
        },
        copyToClipboard(text) {
            const el = document.createElement('textarea');
            el.value = text;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.notifyStatus(200, 'Link Copied', 'The link has been copied to your clipboard.');
        },
        async updateRegistrationAction(registration, action) {
            if (!this.demoCheck()) return;

            await this.dispatchWaitAndNotify('updateGiftBoxRegistration', {registrationId: registration.id, payload: {action: action}});
            await this.dispatchWaitAndNotify('fetchCampaignGiftBoxRegistrations', {campaignId: this.$route.params.id}, false, true);
        },
        filterToYesNo(filter) {
            return this.pageParams.filters[filter].val === true ? 'yes' : (this.pageParams.filters[filter].val === false ? 'no' : 'all');
        },
        toggleFilter(filter, nullable = true) {
            if (this.pageParams.filters[filter].val === null) this.pageParams.filters[filter].val = true;
            else if (this.pageParams.filters[filter].val === true) this.pageParams.filters[filter].val = false;
            else if (this.pageParams.filters[filter].val === false) this.pageParams.filters[filter].val = nullable ? null : true;
            else {
                return;
            }
            this.getPage({resetPagination: true});
        },
        dynamicPropertyValue(value, allowNeutral = false) {
            if (allowNeutral && value === null) return 'all';
            if (value === true | parseInt(value)) return 'yes';
            else return 'no';
        },
        saveDynamicProperty(key, registration, i) {
            if (!this.proCheck('Changing gift registrations')) return;
            if (!this.demoCheck()) return;

            var value = true;
            if (typeof registration[key] === 'object' && registration[key] !== null && registration[key].hasOwnProperty('status') && registration[key].status === true) value = false;
            else if (parseInt(registration[key])) value = false;
            this.registrations.data[i][key] = value;
            this.dispatchWaitAndNotify('updateGiftBoxRegistration', {registrationId: registration.id, payload: {'action': 'sales-update', [key]: value}}, false, true);
        },
        setFilter() {
            this.getPage({resetPagination: true});
        },
        sortBy(field) {
            let copy = JSON.parse(JSON.stringify(this.pageParams.pageOptions)); // VUE reactivity hack https://github.com/vuejs/vue/issues/2164#issuecomment-377517724
            if (copy.sortBy[0] === field) {
                if (copy.sortDesc[0] === false) {
                    copy.sortBy = [];
                    copy.sortDesc = [];
                } else {
                    copy.sortDesc = [false];
                }
            } else {
                copy.sortBy = [field];
                copy.sortDesc = [true];
            }
            this.pageParams.pageOptions = copy;
        },
        sortClass(field, sortBy, sortDesc) { // pageOptions param just to be reactive
            if (this.pageParams.pageOptions.sortBy && this.pageParams.pageOptions.sortBy[0] === field) {
                return {'sort': true, 'sort-up': !this.pageParams.pageOptions.sortDesc[0], 'sort-down': this.pageParams.pageOptions.sortDesc[0]};
            }
            return {};
        },
        onSelectSend() {
            this.getPage({resetPagination: true});
            this.modals.giftRegistrationModal = false;
        },
        onMultiSent() {
            this.getPage({resetPagination: true});
            if (this.multiModalType == 'send') this.modals.giftBoxCampaignsMultiModal = false;
        },
        onLinkGenerate() {
            this.getPage({resetPagination: true});
        },
        onEditRegistration(registration) {
            this.getPage({resetPagination: true});
            this.modals.giftRegistrationModalEdit = false;
        },
        openEditRegistration(reg) {
            if (!this.proCheck('Managing gift registrations')) return;
            this.editRegId = parseInt(reg.id);
            this.modals.giftRegistrationModalEdit = true;
        },
        openNoteModal(reg) {
            if (!this.proCheck('Setting gift registrration notes')) return;
            this.editRegId = parseInt(reg.id);
            this.modals.giftRegistrationNoteModal = true;
        },
        openMultiModal(type) {
            if (!this.proCheck('Sending campaign invites')) return;
            this.multiModalType = type;
            this.batchSecret = null;
            this.modals.giftBoxCampaignsMultiModal = true;
        },
        onEditOption() {
            this.fetchData();
            this.modals.giftBoxCampaignsOptionEdit = false;
        },
        onCreateOption() {
            this.fetchData();
            this.modals.giftBoxCampaignsOptionCreate = false;
        },
        openOptionEditModal(id) {
            if (!this.proCheck('Managing campaign gift options')) return;
            this.editOptionId = id;
            this.modals.giftBoxCampaignsOptionEdit = true;
        },
        openFeedbackModal(r) {
            this.feedbackRegistration = r;
            this.modals.feedbackModal = true;
        },
        resolveEditRegistration(r) {
            if (confirm('Would you like to mark this delivery issue as resolved?')) {
                this.dispatchWaitAndNotify('updateGiftBoxRegistration', {registrationId: r.id, payload: {'action': 'mark-as-resolved'}}, false, true);
            }
        },
		openGiftRegistrationLinkModal(r) {
			if (r) {
				this.editRegId = r.id;
				if (r.shared_secret) this.viewRegistrationLink = this.item.registration_page+'?invite='+r.shared_secret;
				else this.viewRegistrationLink = this.item.registration_page+'?invite='+r.secret;

				this.registrationLinkDetails = {
					'registration_id': r.id,
					'invite_link': this.viewRegistrationLink,
					'password_type': r.password_type,
					'password_value': (r.password_type=='email')?r.email:(r.first_name+' '+r.last_name),
					'batch_label': r.batch_label,
					'is_multi': r.shared_secret!=null,
				};
			} else {
				this.registrationLinkDetails = {};
			}
			this.modals.giftInviteModal = true;
		},
		onNotecardUpdated() {
			this.modals.notecardModal = false;
		},
		giftOptionTypeName(slug) {
			for (let i=0; i!=this.giftOptionTypes.length; i++) if (this.giftOptionTypes[i]['value'] == slug) return this.giftOptionTypes[i]['text'];
		},
		voucherExtraTooltip(text) {
			if (['voucher', 'mixed'].includes(this.item.reward_type)) return '<i>'+text+'</i>';
			else return '';
		},
		registrationMethodName(type) {
          const result = this.giftRegistrationMethods.filter(method => method.type === type);
          if (result.length) return result[0].label;
          else return type;
        },
		showMethodInFilter(method) {
			if (method.type=='unknown') return false;
			else if (method.type=='direct' && this.item.type=='sales') return false;
			else if (method.type=='multiple' && this.item.reward_type!='physical') return false;
			else if (method.type=='public' && this.item.privacy!='public') return false;
			else if (method.type=='external' && !this.team.integrations.length >= 1) return false;
			else return true;
		},
		openBatchDetailModal(sharedSecret) {
			this.batchSecret = sharedSecret;
			this.batchLink = this.item.registration_page+'?invite='+sharedSecret;
			this.modals.batchDetailModal = true;
		},
		addMoreToBatch(batch) {
			this.batch = batch;
			this.multiModalType = this.batch.method == 'multiple'?'send':'link';
			this.modals.batchDetailModal = false;
			this.modals.giftBoxCampaignsMultiModal = true;
		},
		batchRenamed(batch) {
			this.getPage();
		},
		openContactModal() {
			this.$store.state.modals.contactModal = true;
		},
		registrationPaidAmount(r, incVat = false) {
			if (r.rejected_at) return 0;
			if (r.type=='voucher') {
                if (incVat) return parseFloat(r.pp_iv_cost?r.pp_iv_cost:0) + parseFloat(r.voucher_value) + parseFloat(r.extra_charges?r.extra_charges:0);
                else return parseFloat(r.pp_ev_cost?r.pp_ev_cost:0) + parseFloat(r.voucher_value) + parseFloat(r.extra_charges_ev?r.extra_charges_ev:0);
            }
			else {
				if (incVat) return parseInt(r.quantity) * (parseFloat(r.pp_iv_cost) + parseFloat(r.shipping_iv_cost) + (r.notecard_type=='none'?0:1.2)) + parseFloat(r.extra_charges?r.extra_charges:0);
                else return parseInt(r.quantity) * (parseFloat(r.pp_ev_cost) + parseFloat(r.shipping_ev_cost) + (r.notecard_type=='none'?0:1)) + parseFloat(r.extra_charges_ev?r.extra_charges_ev:0);
            }
        },
        verbalRating(rating) {
            if (this.item.reviews && this.item.reviews.buttons && this.item.reviews.buttons[rating]) return this.item.reviews.buttons[rating];
            else return 'Unknown';
        },
		async exportCampaign(campaignId) {
			const csvContent = await this.dispatchWaitAndNotify('exportGiftBoxRegistrations', campaignId);
			var encodedUri = encodeURI("data:text/csv;charset=utf-8,"+csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "worksends-campaign-"+ campaignId +".csv");
			document.body.appendChild(link); 
			link.click();
			link.remove();
		}
    },
    async mounted() {
        this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name);
        try {
            await this.getPage({init: true});
			if (location.hash == '#recipients') this.$refs["recipients"].scrollIntoView({ behavior: "smooth" })

        } catch (e) {
            if (e.response?.status === 404) {
                this.$router.push('/campaigns');
            }
        }
    },
    computed: {
        team() {
            return this.$store.state.team.detail;
        },
        user() {
            return this.$store.state.currentUser;
        },
		item() {
			return this.$store.state.giftBoxCampaign.detail;
		},
		registrations() {
			return this.$store.state.giftBoxCampaign.registrations;
		},
		gbPageUrlBase() {
			return this.$store.state.gbPageUrlBase;
		},
		giftOptionTypes() {
			return this.$store.state.giftOptionTypes;
		},
		giftRegistrationMethods() {
			return this.$store.state.giftRegistrationMethods;
		},
		giftFulfillmentStatus() {
			return this.$store.state.giftFulfillmentStatus;
		},
		privacyLevels() {
			return this.$store.state.privacyLevels;
		},
		modals() {
			return this.$store.state.modals;
		},
		restApiNonce() {
			return window.restApiNonce;
		},
		csvFileName() {
			let date = new Date().toJSON().slice(0,10);
			return 'ws-campaign-'+this.item.id+'-'+date+'.csv';
		},
		registrationSumExtra() {
            if (this.user.permissions && this.user.permissions.includes('view-others-orders')) return '<i>made by your team</i>';
            else return '<i>made by you</i>';
        },
	},
	watch: {
		'pageParams.pageOptions': {
			handler (newVal, oldVal) {
				if (oldVal !== newVal)
					this.getPage();
			},
			deep: true,
		}
	}
}
</script>

<style>

</style>
